import { useEffect } from "react";
import loadjs from "shared/util/loadjs";

const PINGDOM_SDK_URL = "https://rum-static.pingdom.net/pa-5d2f3e8f14cfaa0008000159.js";

function usePingdom() {
	useEffect(() => {
		loadjs(PINGDOM_SDK_URL);
	}, []);
}

export default usePingdom;



// WEBPACK FOOTER //
// ./src/routers/shared/hooks/usePingdom.js